<script setup lang="ts">
const inkwellStyles = useScrollTransformedStyle({
  multiplierX: 0,
  multiplierY: 0.5,
  rotateMultiplier: 0.07,
})

const leftPaperStyles = useScrollTransformedStyle({
  multiplierX: -0.25,
  multiplierY: 0.4,
  rotateMultiplier: 0.05,
})

const rightPaperStyles = useScrollTransformedStyle({
  multiplierX: 0.2,
  multiplierY: 0.35,
  rotateMultiplier: -0.06,
})

const featherPenStyles = useScrollTransformedStyle({
  multiplierX: -0.15,
  multiplierY: 0.6,
  rotateMultiplier: 0.04,
})
</script>

<template>
  <svg class="w-80" width="400" height="400" viewBox="0 0 400 400" overflow="visible" fill="none" xmlns="http://www.w3.org/2000/svg">

    <g :style="inkwellStyles">
      <path d="M116.312 279.079L108.172 274.329C107.312 273.829 106.782 272.909 106.782 271.909V268.759H87.7823V271.909C87.7823 272.899 87.2523 273.819 86.3923 274.329L78.2523 279.079C77.3923 279.579 76.8623 280.499 76.8623 281.489V298.629C76.8623 300.169 78.1123 301.419 79.6523 301.419H114.912C116.452 301.419 117.702 300.169 117.702 298.629V281.489C117.702 280.499 117.172 279.579 116.312 279.079Z" fill="#20460B" />
      <path d="M107.792 265.939H86.7723C86.3967 265.939 86.0923 266.243 86.0923 266.619V268.089C86.0923 268.464 86.3967 268.769 86.7723 268.769H107.792C108.168 268.769 108.472 268.464 108.472 268.089V266.619C108.472 266.243 108.168 265.939 107.792 265.939Z" fill="#DAFEA4" />
    </g>

    <g :style="rightPaperStyles">
      <path d="M151.543 288.895C151.543 288.895 229.763 352.079 317.272 271.477C317.272 271.477 369.044 229.044 357.804 129.501C357.804 129.501 290.591 167.866 236.05 155.06C236.05 155.06 261.168 266.082 151.543 288.895Z" fill="#F8F8F8" />
      <path d="M179.332 304.04C179.332 304.04 216.806 312.445 235.332 274.52C235.332 274.52 278.5 314.677 327.455 260.525C327.455 260.525 265.587 337.954 179.332 304.04Z" fill="#DFE8FF" />
    </g>

    <g :style="leftPaperStyles">
      <path d="M114.331 250.042C114.331 250.042 84.3882 261.135 44.1769 197.853C58.5157 187.391 76.503 179.669 93.9746 156.027C134.186 219.309 164.129 208.216 164.129 208.216C150.896 228.616 134.46 242.877 114.331 250.042Z" fill="#F8F8F8" />
      <path d="M164.13 208.216C164.13 208.216 139.722 224.915 116.394 225.617C116.394 225.617 133.246 235.827 114.332 250.042L164.13 208.216Z" fill="#DFE8FF" />
      <path d="M164.13 208.216C164.13 208.216 142.239 243.285 114.332 250.042L164.13 208.216Z" fill="#DFE8FF" />
    </g>

    <g :style="featherPenStyles">
      <path d="M230.198 207.151C166.409 146.427 103.391 124.417 103.391 124.417C106.588 133.331 110.275 141.213 114.315 148.194L120.622 151.311L118.249 154.575C124.598 164.176 131.64 171.84 138.932 177.949L144.189 177.156L141.087 179.701C173.687 205.535 210.109 201.375 210.109 201.375L210.682 204.907L230.211 207.157L230.198 207.151Z" fill="#DAFEA4" />
      <path d="M124.722 146.26C124.722 146.26 141.451 144.308 153.806 149.266" stroke="#20460B" stroke-width="0.962909" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M135.925 158.548C135.925 158.548 161.685 156.575 181.822 167.435" stroke="#20460B" stroke-width="0.962909" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M171.391 176.169C171.391 176.169 198.731 180.66 208.408 187.788" stroke="#20460B" stroke-width="0.962909" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M119.039 130.954C119.039 130.954 163.435 149.352 217.113 195.2" stroke="#20460B" stroke-width="0.962909" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M248.071 223.83C247.84 224.182 247.533 224.497 247.128 224.708C245.902 225.342 244.388 224.867 243.754 223.641C243.158 222.497 243.541 221.12 244.576 220.423C237.098 213.222 230.199 207.15 230.199 207.15C242.971 222.888 244.129 236.594 244.129 236.594C251.93 233.358 262.352 240.404 262.352 240.404C260.347 236.549 254.358 230.065 248.074 223.839L248.071 223.83Z" fill="#A3B5FE" />
    </g>
  </svg>
</template>
